module.exports = __webpack_public_path__ + "img/note-green-small-icon.2122eca8.svg";